import { render, staticRenderFns } from "./SoliText.vue?vue&type=template&id=225d8a6b"
import script from "./SoliText.vue?vue&type=script&lang=js"
export * from "./SoliText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports